export const scenarioModule = {
  namespaced: true,
  state: {
    scenarios: [
      { 
        id: "1", 
        name: "My first scenario",
        facts: ["First fact of the day", "Another fact", "10000 supporters"],
        // maps: [{name: "City", image: require("@/assets/map1.png")}, {name: "Stadium", image: require("@/assets/map2.png")}],
        playlists: ["1", "2"],
        duration: 60*60,
        trainer: {name: 'J. Doe'},
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus viverra felis in risus dapibus pretium. Ut ut sagittis risus. Suspendisse eget est sed est sodales rhoncus ac a tortor. Vivamus purus nisl, varius ut augue eu, finibus gravida felis. Donec neque libero, hendrerit iaculis convallis quis, faucibus id lacus. Proin eget pharetra augue, nec ultricies neque. Morbi cursus arcu ut leo mattis malesuada. Nulla placerat quam varius, egestas lectus vel, tempus quam. Sed sit amet fermentum nunc.<br><br>Fusce vestibulum lectus convallis viverra aliquet. Ut id erat dolor. Cras scelerisque sapien quis nisi suscipit, sed faucibus velit scelerisque. In consectetur bibendum lectus, vel ultricies nibh ullamcorper eget. Ut vitae nibh quis nisi consectetur pharetra vitae ut arcu. In sed fermentum tortor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi bibendum dui nisl, id porttitor ex vestibulum blandit. Cras sagittis mauris sed nisi luctus sollicitudin. Aenean a dolor vitae turpis dapibus elementum et nec lectus. Nulla rutrum lobortis leo, eu suscipit felis vehicula a. Fusce sit amet leo nunc. Maecenas lacinia turpis at ligula gravida rutrum eu eget purus.",
        dateCreated: "20-04-2020",
        createdBy: "Marc Otten",
        language: "English",
        nextScenario: "2",
      },
      { 
        id: "2", 
        name: "The second scenario",
        playlists: ["3", "4"],
        duration: 60*45,
        trainer: {name: 'S. Frosdick'},
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus viverra felis in risus dapibus pretium. Ut ut sagittis risus. Suspendisse eget est sed est sodales rhoncus ac a tortor. Vivamus purus nisl, varius ut augue eu, finibus gravida felis. Donec neque libero, hendrerit iaculis convallis quis, faucibus id lacus. Proin eget pharetra augue, nec ultricies neque. Morbi cursus arcu ut leo mattis malesuada. Nulla placerat quam varius, egestas lectus vel, tempus quam. Sed sit amet fermentum nunc.<br><br>Fusce vestibulum lectus convallis viverra aliquet. Ut id erat dolor. Cras scelerisque sapien quis nisi suscipit, sed faucibus velit scelerisque. In consectetur bibendum lectus, vel ultricies nibh ullamcorper eget. Ut vitae nibh quis nisi consectetur pharetra vitae ut arcu. In sed fermentum tortor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi bibendum dui nisl, id porttitor ex vestibulum blandit. Cras sagittis mauris sed nisi luctus sollicitudin. Aenean a dolor vitae turpis dapibus elementum et nec lectus. Nulla rutrum lobortis leo, eu suscipit felis vehicula a. Fusce sit amet leo nunc. Maecenas lacinia turpis at ligula gravida rutrum eu eget purus.",
        dateCreated: "21-04-2020",
        createdBy: "Marc Otten",
        language: "English",
        nextScenario: "3",
      },
      { 
        id: "3", 
        name: "Plenary scenario (UEFA stadium & security events)",
        playlists: ["a1", "a2-1", "a2-2", "a2-3", "a2-4", "a3-1", "a3-2", "a3-3", "a4"],
        duration: 60*45,
        trainer: {name: 'S. Frosdick'},
        description: "<p>This exercise has been developed to train police commanders and law enforcement for the UEFA EURO 2012 tournament hosted in Poland and Ukraine. It is based on a careful reconstruction of actual events that occurred in past UEFA tournaments  - and the decision-making that was required.</p> <p>In the scenario “Approach to the stadium” we visit some of the challenges that may be faced when a major football match comes to town. You are now invited to take the hot seat yourself – and face situations that need to be resolved.</p>",
        context: "<h4>Background information</h4><p>Drax city is the big rival of SIM city. The city is the second-largest city in the country. </p><p>Drax city is the most important city in the more heavily industrialised northwest of the country. Many important global corporations have their headquarters in Drax. </p><p>The mayor is a former union official and is known for his technocratic style of government. He is strong on public government, protecting welfare and social institutions in the city and stresses the importance of financial sound investments. </p><p>In the past, he has voiced reservations on the investments required for hosting the tournament. However, he now has promised that Drax will do everything possible to make supporters feel home in his city. </p><h4>Geography</h4>		<ul><li>Location: Drax city land is situated near the Atlantic ocean in the north-west of the country. </li><li>Area: The land area covers 41 square km; the metropolitan area extends to 389 square km</li><li>Terrain: dry, rocky terrain with large beaches </li><li>Climate: cool-summer Mediterranean climate  with warm, dry summers and mild, rainy winters. Unlike the south, however, cool and rainy interludes can interrupt the dry season.</li></ul><h4>Population</h4>						<ul><li>City population: 220’000.</li><li>Metropolitan area: 1.3 million.</li><li>Visitors annually:  7th most visited city in Europe with about 2 million tourist every year</li></ul><h4>Government</h4>								<ul><li>National political system: republic; parliamentary democracy.</li><li>City government: elected mayor and city council (suffrage 18 years of age; universal) </li><li>Legislative branch: city council elected (30 seats, for four years, next to be held next year) </li><li>Executive branch: cabinet of Mayor and Aldermen</li><li>Legal system: based on civil law system and European law. Judges appointed for life.</li></ul><h4>Transport</h4><p>Drax is served by Drax International Airport which is located some 15 km to the north-west of the city centre. The airport is a state-of-the-art facility, due to refurbishment because of the football championships. </p><p>The city has the biggest metro system in the country with 60 km and using 68 stations and it has an extensive bus network. </p><h4>Stadium</h4><p>Football is the most important sport in the city. There are three main teams in Drax. FC Drax is one of the major clubs in the country. Drax plays in Drax stadium – the biggest stadium in the city. </p><p>The stadium is a 50’000 seater. The municipality owns the stadium. It is located approximately 6 Km from the city centre. There a good bus and metro links to the stadium. </p>",
        dateCreated: "22-04-2020",
        createdBy: "Steve Frosdick",
        language: "English",
        plenary: true,
        nextScenario: "1",
      },
      { 
        id: "10", 
        name: "Match operations (UEFA MOC)",
        playlists: ["w1", "g1", "g2", "g3", "g4"],
        duration: 60*45,
        trainer: {name: 'S. Frosdick'},
        description: "<p>This exercise has been developed to train UEFA venue directors in crisis management during matches in UEFA competitions. Venue directors need to provide leadership when unexpected events take place before, during or after matches. Think of a fire in the stadium, a break down of floodlights, severe weather conditions and other safety and security issues. </p><p>We have selected some real-time incidents that actually happened and then ask participants to reflect and provide responses on a host of issues. Do matches need to be halted, stopped or postponed? What are the appropriate decision-making and communication procedures?  What do you need to tell the media?  These and other considerations are practiced with the use of video inputs. </p>",
        dateCreated: "08-05-2020",
        createdBy: "Steve Frosdick",
        language: "English",
        plenary: false,
        nextScenario: null,
      },
      // { 
      //   id: "11", 
      //   name: "Greenpeace protest ",
      //   playlists: ["g1", "g2", "g3", "g4"],
      //   duration: 60*45,
      //   trainer: {name: 'S. Frosdick'},
      //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus viverra felis in risus dapibus pretium. Ut ut sagittis risus. Suspendisse eget est sed est sodales rhoncus ac a tortor. Vivamus purus nisl, varius ut augue eu, finibus gravida felis. Donec neque libero, hendrerit iaculis convallis quis, faucibus id lacus. Proin eget pharetra augue, nec ultricies neque. Morbi cursus arcu ut leo mattis malesuada. Nulla placerat quam varius, egestas lectus vel, tempus quam. Sed sit amet fermentum nunc.<br><br>Fusce vestibulum lectus convallis viverra aliquet. Ut id erat dolor. Cras scelerisque sapien quis nisi suscipit, sed faucibus velit scelerisque. In consectetur bibendum lectus, vel ultricies nibh ullamcorper eget. Ut vitae nibh quis nisi consectetur pharetra vitae ut arcu. In sed fermentum tortor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi bibendum dui nisl, id porttitor ex vestibulum blandit. Cras sagittis mauris sed nisi luctus sollicitudin. Aenean a dolor vitae turpis dapibus elementum et nec lectus. Nulla rutrum lobortis leo, eu suscipit felis vehicula a. Fusce sit amet leo nunc. Maecenas lacinia turpis at ligula gravida rutrum eu eget purus.",
      //   dateCreated: "08-05-2020",
      //   createdBy: "Steve Frosdick",
      //   language: "English",
      //   plenary: false,
      //   nextScenario: null,
      // },
      { 
        id: "12", 
        name: "Approach to stadium (UEFA EURO Tournaments)",
        playlists: ["a1", "a2-1", "a2-2", "a2-3", "a2-4", "a3-1", "a3-2", "a3-3", "a4"],
        duration: 60*45,
        trainer: {name: 'S. Frosdick'},
        description: "<p>This exercise has been developed to train police commanders and law enforcement for the UEFA EURO 2012 tournament hosted in Poland and Ukraine. It is based on a careful reconstruction of actual events that occurred in past UEFA tournaments  - and the decision-making that was required.</p> <p>In the scenario “Approach to the stadium” we visit some of the challenges that may be faced when a major football match comes to town. You are now invited to take the hot seat yourself – and face situations that need to be resolved.</p>",
        context: "<h4>Background information</h4><p>Drax city is the big rival of SIM city. The city is the second-largest city in the country. </p><p>Drax city is the most important city in the more heavily industrialised northwest of the country. Many important global corporations have their headquarters in Drax. </p><p>The mayor is a former union official and is known for his technocratic style of government. He is strong on public government, protecting welfare and social institutions in the city and stresses the importance of financial sound investments. </p><p>In the past, he has voiced reservations on the investments required for hosting the tournament. However, he now has promised that Drax will do everything possible to make supporters feel home in his city. </p><h4>Geography</h4>		<ul><li>Location: Drax city land is situated near the Atlantic ocean in the north-west of the country. </li><li>Area: The land area covers 41 square km; the metropolitan area extends to 389 square km</li><li>Terrain: dry, rocky terrain with large beaches </li><li>Climate: cool-summer Mediterranean climate  with warm, dry summers and mild, rainy winters. Unlike the south, however, cool and rainy interludes can interrupt the dry season.</li></ul><h4>Population</h4>						<ul><li>City population: 220’000.</li><li>Metropolitan area: 1.3 million.</li><li>Visitors annually:  7th most visited city in Europe with about 2 million tourist every year</li></ul><h4>Government</h4>								<ul><li>National political system: republic; parliamentary democracy.</li><li>City government: elected mayor and city council (suffrage 18 years of age; universal) </li><li>Legislative branch: city council elected (30 seats, for four years, next to be held next year) </li><li>Executive branch: cabinet of Mayor and Aldermen</li><li>Legal system: based on civil law system and European law. Judges appointed for life.</li></ul><h4>Transport</h4><p>Drax is served by Drax International Airport which is located some 15 km to the north-west of the city centre. The airport is a state-of-the-art facility, due to refurbishment because of the football championships. </p><p>The city has the biggest metro system in the country with 60 km and using 68 stations and it has an extensive bus network. </p><h4>Stadium</h4><p>Football is the most important sport in the city. There are three main teams in Drax. FC Drax is one of the major clubs in the country. Drax plays in Drax stadium – the biggest stadium in the city. </p><p>The stadium is a 50’000 seater. The municipality owns the stadium. It is located approximately 6 Km from the city centre. There a good bus and metro links to the stadium. </p>",
        dateCreated: "08-05-2020",
        createdBy: "Steve Frosdick",
        language: "English",
        plenary: false,
        nextScenario: null,
      },
      { 
        id: "13", 
        name: "Pyrotechnics training on the job  (Clubs)",
        playlists: ["p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8", "p9", "p10", "p11", "p12", "p13", "p14", "p15"],
        duration: 60*45,
        trainer: {name: 'S. Frosdick'},
        description: "<p>This playlist has been developed to train stewards on the job. The aim is to use the down time on the job – think of the time which is left before the first supporters come into the stadium – to increase awareness of risks in dealing with pyrotechnics, to train procedures, to rehearse routines or to learn about the newest updates.</p><p>This sample is based on a real case that happened in UEFA EURO 2016 and reconstructs the order of events involving throwing of several pyrotechnics on the pitch during a match. At each stage, stewards are asked about their primary assessment and responses.</p>",
        dateCreated: "08-05-2020",
        createdBy: "Steve Frosdick",
        language: "English",
        plenary: false,
        nextScenario: null,
      }
    ],
    playlists: [
      {
        id: "1",
        name: "First playlist",
        injects: ["1", "2", "3", "4"],
        location: "stadium", 
        duration: 60 * 15,
        timeSlot: "33",
        items: [
          { 
            id: "0",
            type: "rank",
            max: "3",
            question: "Rank these options?",
            instruction: "Drag and drop the options, only the top 3 counts",
            options: [{id:"1",label:"First answer"}, {id:"2",label:"Second answer"}, {id:"3",label:"Best answer"}, {id:"4",label:"Not too shabby"}]
          },
          { 
            id: "1",
            type: "radio",
            question: "What is the best option?",
            instruction: "Pick one of the options below",
            options: [{id:"1",label:"First answer"}, {id:"2",label:"Second answer"}, {id:"3",label:"Best answer"}, {id:"4",label:"Not too shabby"}]
          },
          { 
            id: "2",
            type: "checkbox",
            question: "What have you done?",
            instruction: "Pick whatever applies",
            options: [{id:"1",label:"First answer"}, {id:"2",label:"Second answer"}, {id:"3",label:"Best answer"}, {id:"4",label:"Not too shabby"}]
          },
          { 
            id: "3",
            type: "decision",
            question: "What is the best course of action to take when dealing with a flare on the pitch?",
            instruction: "Take 15 minutes to answer your question.<br>Don't forget about the notes and location information we've provided.",
          },
          { 
            id: "4",
            type: "decision",
            question: "Do you like this question?",
            instruction: "Type fast.",
          },
          { 
            id: "5",
            type: "decision",
            question: "What is the best course of action to take when dealing with a flare on the pitch?",
            instruction: "Take 2 hours to answer your question.<br>Don't forget about the notes and location information we've provided.",
          },
        ]
      },
      {
        id: "2",
        name: "Second playlist",
        injects: ["12", "12b", "12c"],
        location: "stadium", 
        duration: 60 * 1,
        timeSlot: "50",
        items: [
          { 
            id: "22",
            type: "decision",
            question: "Do you like this question?",
            instruction: "Type fast.",
          }
        ]
      },
      {
        id: "3",
        name: "Third playlist",
        injects: ["1", "2", "3", "4"],
        location: "city", 
        duration: 60 * 15,
        timeSlot: "33",
        items: [
          { 
            id: "1",
            type: "decision",
            question: "What is the best course of action to take when dealing with a flare on the pitch?",
            instruction: "Take 15 minutes to answer your question.<br>Don't forget about the notes and location information we've provided.",
          },
          { 
            id: "22",
            type: "decision",
            question: "Do you like this question?",
            instruction: "Type fast.",
          },
          { 
            id: "333",
            type: "decision",
            question: "What is the best course of action to take when dealing with a flare on the pitch?",
            instruction: "Take 2 hours to answer your question.<br>Don't forget about the notes and location information we've provided.",
          },
        ]
      },
      {
        id: "4",
        name: "Fouth playlist",
        injects: ["1"],
        location: "city", 
        duration: 60 * 1,
        timeSlot: "50",
        items: [
          { 
            id: "22",
            type: "decision",
            question: "Do you like this question?",
            instruction: "Type fast.",
          }
        ]
      },
      {
        id: "pl1",
        name: "Plenary playlist",
        injects: [],
        location: "country", 
        timeSlot: "23",
        items: [
          { 
            id: "22",
            type: "decision",
            question: "Do you like plenary sessions?",
            instruction: "Intruction for all of you.",
          },
          { 
            id: "23",
            type: "decision",
            question: "What is your opinion about this?",
            instruction: "Type fast.",
          },
          { 
            id: "24",
            type: "decision",
            question: "More decisions to make",
            instruction: "Type fast.",
          }
        ]
      },
      {
        id: "pl2",
        name: "Another plenary playlist",
        injects: [],
        location: "country", 
        timeSlot: "68",
        items: [
          { 
            id: "22",
            type: "decision",
            question: "Do you like plenary sessions?",
            instruction: "Intruction for all of you.",
          },
          { 
            id: "23",
            type: "decision",
            question: "What is your opinion about this?",
            instruction: "Type fast.",
          },
          { 
            id: "24",
            type: "decision",
            question: "More decisions to make",
            instruction: "Type fast.",
          }
        ]
      },
      {
        id: "w1",
        name: "Weather contingency",
        injects: ["10"],
        location: "stadium", 
        timeSlot: "33",
        duration: 60 * 15,
        items: [
          { 
            id: "1",
            type: "decision",
            question: "As Venue Director what information would you be seeking from the venue when the match is initially halted?",
            instruction: "Please share this information with your group and list the bullet points in your response.",
          },
          { 
            id: "2",
            type: "decision",
            question: "In considering your own response to the stoppage of the match what information would you be seeking from which partner? ",
            instruction: "",
          },
          { 
            id: "3",
            type: "decision",
            question: "What would be the impact if the match is not able to restart?",
            instruction: "",
          },
          { 
            id: "4",
            type: "decision",
            question: "Within the UEFA Match Control Centre what are the considerations for escalation of communication?",
            instruction: "Assume no UEFA senior management are at the venue",
          },
          { 
            id: "5",
            type: "decision",
            question: "How do you ensure that the onsite staff are communicating effectively necessary information to the UEFA Match Control Centre?",
            instruction: "",
          },
          { 
            id: "6",
            type: "decision",
            question: "Taking this scenario as a whole what are the critical factors in ensuring a successful outcome?",
            instruction: "",
          }
        ]
      },
      {
        id: "g1",
        name: "Greenpeace, Basel v Schalke",
        injects: ["11"],
        location: "stadium", 
        timeSlot: "33",
        duration: 60 * 15,
        items: [
          { 
            id: "1",
            type: "decision",
            question: "The first abseiler is seen descending from the roof of the main tribune. Given the presence of senior UEFA management in the stadium, how does this affect the communication and escalation procedure?",
            instruction: "",
          },
          { 
            id: "2",
            type: "decision",
            question: "An urgent update is requested for the UEFA president who is at the venue.",
            instruction: "Please give an update in bullet points based on the video shown.",
          },
          { 
            id: "3",
            type: "decision",
            question: "What needs to be addressed in the meeting between the club and the UEFA delegate at this time?",
            instruction: "Present an overview of topics and briefing notes.",
          },
          { 
            id: "4",
            type: "decision",
            question: "After the event: what issues should be clarified with the club, stadium management and police?",
            instruction: "",
          }
        ]
      },
      {
        id: "g2",
        name: "Home team cheerleaders ",
        injects: ["12"],
        location: "stadium", 
        timeSlot: "45",
        duration: 60 * 15,
        items: [
          { 
            id: "1",
            type: "decision",
            question: "The on site media officer is asking what he can tell the press.",
            instruction: "Please discuss in your team and provide detailed instructions.",
          },
          { 
            id: "2",
            type: "decision",
            question: "The competitions director wishes to be re-assured that the incident is over.",
            instruction: "What do you reply at this stage?",
          },
          { 
            id: "3",
            type: "decision",
            question: "What should the UEFA media strategy be at this time?",
            instruction: "",
          }
        ]
      },
      {
        id: "g3",
        name: "FC Basel Meeting",
        injects: ["13"],
        location: "stadium", 
        timeSlot: "60",
        duration: 60 * 15,
        items: [
          { 
            id: "1",
            type: "decision",
            question: "Please read the debrief report. What additional action points do you identify for your domain for future matches?",
            instruction: "",
          },
          { 
            id: "2",
            type: "decision",
            question: "What is the impact of this event for the communication process for each domain for matches the following night?",
            instruction: "",
          }
        ]
      },
      {
        id: "g4",
        name: "Greenpeace, Kopenhagen v Real Madrid",
        injects: ["4"],
        location: "stadium", 
        timeSlot: "80",
        duration: 60 * 15,
        items: [
          { 
            id: "1",
            type: "decision",
            question: "You see this incident “live”. What should be the key actions for the MCC in response?",
            instruction: "",
          },
          { 
            id: "2",
            type: "decision",
            question: "Read the overview. What are your suggestions for UEFA Match Control Centre dealing with such protest campaigns in UEFA competitions?",
            instruction: "Please discuss and outline your plan of action and be ready to present this to the other groups.",
          }
        ]
      },
      {
        id: "a1",
        name: "Fan Zones",
        injects: ["a1"],
        location: "city", 
        timeSlot: "10",
        facts: ['Room for facts'],
        maps: [
          {name: "Square", image: require("@/assets/3.1/3.1-klein.png")}, 
          {name: "Fan Zones", image: require("@/assets/3.1/3.1.1.png")}, 
          {name: "German Fan Zone", image: require("@/assets/3.1/3.1.2.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.1/3.1.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "How do you <b>police the fan zones</b>?",
            instruction: "Please indicate how you address safety, security and service in your strategy.",
            duration: 60 * 2
          },
          { 
            id: "2",
            type: "decision",
            question: "As police, how do you <b>facilitate non-risk supporters</b>?",
            instruction: "Please clarify your plan.",
            duration: 30 * 1
          },
        ]
      },
      {
        id: "a2-1",
        name: "Other Areas",
        injects: ["a2"],
        location: "city", 
        timeSlot: "20",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Route Start", image: require("@/assets/3.2/3.2.1.png")}, 
          {name: "Route", image: require("@/assets/3.2/3.2.2.png")}, 
          {name: "Route End", image: require("@/assets/3.2/3.2.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "What is your <b>contingency plan</b> if the fan zones attendance exceeds safe capacity?",
            instruction: "Please clarify your plan.",
          },
          { 
            id: "2",
            type: "decision",
            question: "How do you plan to get reliable <b>information on fans' intentions and behaviour</b>?",
            instruction: "Please list your intelligence sources.",
          }
        ]
      },
      {
        id: "a2-2",
        name: "ESA website Twitters",
        injects: ["a3"],
        location: "city", 
        timeSlot: "25",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Route Start", image: require("@/assets/3.2/3.2.1.png")}, 
          {name: "Route", image: require("@/assets/3.2/3.2.2.png")}, 
          {name: "Route End", image: require("@/assets/3.2/3.2.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "What is your <b>risk assessment</b> given the twitters/feeds on the ESA site?",
            instruction: "Please describe your assessment in key words.",
          },
          { 
            id: "2",
            type: "decision",
            question: "What are your <b>options</b> to ensure that fans will go to the planned fan zones?",
            instruction: "Please list possible actions.",
          },
          { 
            id: "3",
            type: "decision",
            question: "What are the implications for your policing strategy <b>if and when fans go to other areas in the city</b>?",
            instruction: "Please identify the key issues.",
          }
        ]
      },
      {
        id: "a2-3",
        name: "RT Website 24-7/ Media Feeds",
        injects: ["a4"],
        location: "city", 
        timeSlot: "30",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Route Start", image: require("@/assets/3.2/3.2.1.png")}, 
          {name: "Route", image: require("@/assets/3.2/3.2.2.png")}, 
          {name: "Route End", image: require("@/assets/3.2/3.2.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "Does the <b>mixing of fans</b> from the different countries represent a risk?",
            instruction: "Please describe your assessment in key words.",
          },
          { 
            id: "2",
            type: "decision",
            question: "Does the <b>consumption of alcohol</b> change the risks posed by the situation?",
            instruction: "Please answer (yes/no) and explain your answer.",
          },
          { 
            id: "3",
            type: "decision",
            question: "Do groups of <b>fans drinking in the bars</b> in the Ribera area require a police response?",
            instruction: "Please answer (yes/no) and explain measures you consider.",
          }
        ]
      },
      {
        id: "a2-4",
        name: "Police Intelligence German spotters",
        injects: ["a5"],
        location: "city", 
        timeSlot: "35",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Route Start", image: require("@/assets/3.2/3.2.1.png")}, 
          {name: "Route", image: require("@/assets/3.2/3.2.2.png")}, 
          {name: "Route End", image: require("@/assets/3.2/3.2.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "How do you <b>grade the risks</b> these fans pose?",
            instruction: "Please indicate the level of risk (low/medium/high) and provide a short rationale",
          },
          { 
            id: "2",
            type: "decision",
            question: "What are your instructions for the <b>foreign police spotters</b> in this case?",
            instruction: "Please include your instructions.",
          }
        ]
      },
      {
        id: "a3-1",
        name: "March planned",
        injects: ["a6"],
        location: "city", 
        timeSlot: "50",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Fan Zones", image: require("@/assets/3.3/3.3-klein.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.3/3.3.1.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.3/3.3.2.png")}, 
          {name: "Stadium Route", image: require("@/assets/3.3/3.3.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "Do you <b>allow the spontaneous marches</b>?",
            instruction: "Please answer (yes/no) and provide a rationale.",
          },
          { 
            id: "2",
            type: "decision",
            question: "Do you <b>facilitate</b> the fan march?",
            instruction: "Please answer (yes/no) and list the measures you consider.",
          }
        ]
      },
      {
        id: "a3-2",
        name: "Reporter Patriarch Square",
        injects: ["a7"],
        location: "city", 
        timeSlot: "55",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Fan Zones", image: require("@/assets/3.3/3.3-klein.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.3/3.3.1.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.3/3.3.2.png")}, 
          {name: "Stadium Route", image: require("@/assets/3.3/3.3.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "What are your options to <b>control crowd movement</b> along the route of 6km form fan zone to stadium?",
            instruction: "Please list your options.",
          },
          { 
            id: "2",
            type: "decision",
            question: "How do you <b>grade the risk</b> of these events?",
            instruction: "Please indicate the level of risk (low/medium/high) and provide a short rationale.",
          }
        ]
      },
      {
        id: "a3-3",
        name: "Item Presenter – busy intersection  ",
        injects: ["a8"],
        location: "city", 
        timeSlot: "60",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Fan Zones", image: require("@/assets/3.3/3.3-klein.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.3/3.3.1.png")}, 
          {name: "Dutch Fan Zone", image: require("@/assets/3.3/3.3.2.png")}, 
          {name: "Stadium Route", image: require("@/assets/3.3/3.3.3.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "What is your plan for dealing with any congestion issues and other safety risks involved in the fan march?",
            instruction: "Please clarify your plan.",
          },
          { 
            id: "2",
            type: "decision",
            question: "What units do you deploy in this situation?",
            instruction: "Please indicate which units you would like to deploy. You may consider for example foot patrols/motorised patrols/horse unites/dog units/cars/riot vans or a water cannon.",
          },
          { 
            id: "3",
            type: "decision",
            question: "How will you deal with the sit down at the intersection?",
            instruction: "Please list possible actions.",
          }
        ]
      },
      {
        id: "a4",
        name: "Confrontation",
        injects: ["a9"],
        location: "city", 
        timeSlot: "70",
        duration: 60 * 15,
        facts: ['Room for facts'],
        maps: [
          {name: "Square Start", image: require("@/assets/3.4/3.4.1.png")}, 
          {name: "Square End", image: require("@/assets/3.4/3.4.2.png")}
        ],
        items: [
          { 
            id: "1",
            type: "decision",
            question: "What additional information would you like to receive to improve your understanding of the situation?",
            instruction: "Please identify the key topics.",
          },
          { 
            id: "2",
            type: "decision",
            question: "What are your instructions for the foreign police spotters in this case?",
            instruction: "Please include your instructions.",
          },
          { 
            id: "3",
            type: "decision",
            question: "What are your instructions for foreign police spotters in case of incidents with supporters from competing countries?",
            instruction: "Please include your instructions for evidence gathering.",
          },
          { 
            id: "4",
            type: "decision",
            question: "How will you deploy your police in the case of arrests to be made?",
            instruction: "Please clarify your course of action.",
          },
          { 
            id: "5",
            type: "decision",
            question: "In what way should foreign police spotters assist local police when supporters from foreign countries are involved in incidents and are arrested?",
            instruction: "Please present a short overview of supporting activities.",
          }
        ]
      },
      {
        id: "p1",
        quickEvent: true,
        name: "Pyrotechnics thrown onto the pitch – product knowledge (UEFA EURO 2016)",
        injectsTitle: "Take a close look at the devices that are being thrown.",
        injects: ["p1"],
        outcomes: ["lo1-1", "lo1-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+1.jpg",
        tags: ["Pyro Product Knowledge", "Removal"],
        subTags: ["Pyro Product Knowledge"],
        location: "stadium", 
        duration: 60 * 5,
        items: [
          { 
            id: "1a",
            type: "radio",
            question: "What type of pyrotechnic is it?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["8"],
            options: [{id:"1",label:"Flare"}, {id:"2",label:"Smoke device"}, {id:"3",label:"Banger (maroon)"}, {id:"4",label:"Whistle"}, {id:"5",label:"Strobe"}, {id:"6",label:"Roman Candle"}, {id:"7",label:"Rocket"}, {id:"8",label:"I do not know"}]
          },
          { 
            id: "1b",
            type: "radio",
            question: "Will you attempt to remove the pyrotechnic from the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No"}]
          },
        ]
      },
      {
        id: "p2",
        quickEvent: true,
        name: "Multiple pyrotechnics - product knowledge (UEFA EURO 2016)",
        injectsTitle: "Notice the multiple devices that land on the pitch.",
        injects: ["p2"],
        outcomes: ["lo2-1", "lo2-2", "lo2-3", "lo2-4"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+2.jpg",
        tags: ["Pyro Product Knowledge"],
        subTags: ["Pyro Product Knowledge"],
        location: "stadium", 
        duration: 60 * 5,
        items: [
          { 
            id: "2a",
            type: "checkbox",
            question: "What type are the pyrotechnics on the pitch?",
            instruction: "Tick all that apply",
            duration: 60 * 0.5,
            correct: ["1", "3"],
            options: [{id:"1",label:"Flares"}, {id:"2",label:"Smoke devices"}, {id:"3",label:"Bangers (maroons)"}, {id:"4",label:"Whistles"}, {id:"5",label:"Rockets"}, {id:"6",label:"I do not know"}]
          },
          { 
            id: "2b",
            type: "radio",
            question: "Are any of these pyrotechnics about to explode?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["3"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No"}, {id:"3",label:"I cannot tell"}]
          },
        ]
      },
      {
        id: "p3",
        quickEvent: true,
        name: "Multiple pyrotechnics – assessment (UEFA EURO 2016)",
        injectsTitle: "Look at the series of devices that land on the pitch.",
        injects: ["p3"],
        outcomes: ["lo3-1", "lo3-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+3.jpg",
        tags: ["Pyro Product Knowledge", "Situation And Risk Assessment"],
        subTags: ["Multiple Flares"],
        location: "stadium", 
        duration: 60 * 5,
        items: [
          { 
            id: "3a",
            type: "radio",
            question: "You see that there is more than one pyrotechnic thrown onto the pitch.<br>Does this change the approach you take for dealing with that pyrotechnic?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No"}]
          },
          { 
            id: "3b",
            type: "radio",
            question: "Are all the pyrotechnics on the pitch the same?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["1"],
            options: [{id:"1",label:"I cannot tell"}, {id:"2",label:"Yes – they all look like flares"}, {id:"3",label:"No – I can see several different types"}]
          },
          { 
            id: "3c",
            type: "checkbox",
            question: "Multiple flares land on the pitch burning. What may be the harm done to the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            // correct: ["1"],
            options: [{id:"1",label:"The pitch may catch fire"}, {id:"2",label:"The pitch may have severe damage"}, {id:"3",label:"The match may need to be halted"}, {id:"4",label:"The players may be harmed"}]
          },
          { 
            id: "3d",
            type: "checkbox",
            question: "What should be the first response to this situation?",
            instruction: "You may choose several options",
            duration: 60 * 0.5,
            correct: ["2", "3"],
            options: [{id:"1",label:"Pitch side stewards need to quickly remove the devices from the pitch"}, {id:"2",label:"Stewards in the away stand need to intervene and stop the devices being thrown"}, {id:"3",label:"Pitch side stewards need to wait until the devices are burnt out"}, {id:"4",label:"Trained firemen need to remove the devices from the pitch immediately"}]
          },
        ]
      },
      {
        id: "p4",
        quickEvent: true,
        name: "Movement towards pyrotechnics – stewards (UEFA EURO 2016)",
        injectsTitle: "Observe the behaviour of the stewards in response to the pyrotechnics.",
        injects: ["p4"],
        outcomes: ["lo4-1", "lo4-2", "lo4-video", "lo4-3"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+4.jpg",
        tags: ["Movement"],
        subTags: ["Safety Distance"],
        location: "stadium", 
        duration: 60 * 20,
        items: [
          { 
            id: "4a",
            type: "checkbox",
            question: "If you were one of the stewards on the left of the image what would you do next?",
            instruction: "Tick all that apply",
            duration: 60 * 0.5,
            correct: ["1", "3"],
            options: [{id:"1",label:"Move away from the pyrotechnics – and upwind"}, {id:"2",label:"Move onto the pitch towards the pyrotechnics"}, {id:"3",label:"Try and keep players and officials away from the pyrotechnics"}, {id:"4",label:"Move downwind in order to warn spectators"}]
          },
          { 
            id: "4b",
            type: "radio",
            question: "How close can you get to these (this) type of pyrotechnics?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"You need to stay away at least 10 mtrs"}, {id:"2",label:"You need to stay away at least 5 mtrs"}, {id:"3",label:"You need to stay away at least 2 mtrs"}, {id:"4",label:"You can get as close as you need to be "}]
          },
          { 
            id: "4c",
            type: "checkbox",
            question: "How can you tell the safety distance of any type of pyrotechnics?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2", "3"],
            options: [{id:"1",label:"You can see it on the device"}, {id:"2",label:"You need to check the CE mark on the device"}, {id:"3",label:"You can't tell with any of these devices"}]
          }
        ]
      },
      {
        id: "p5",
        quickEvent: true,
        name: "Movement towards pyrotechnics – players (UEFA EURO 2016)",
        injectsTitle: "Observe the behaviour of the players in response to the pyrotechnics.",
        injects: ["p5"],
        outcomes: ["lo5-1", "lo5-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+5.jpg",
        tags: ["Situation And Risk Assessment"],
        subTags: ["Situation And Risk Assessment"],
        location: "stadium", 
        duration: 60 * 10,
        items: [
          { 
            id: "5a",
            type: "radio",
            question: "Is the player to CLOSE these (this) type of pyrotechnics?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["1"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No"}]
          },
          { 
            id: "5b",
            type: "radio",
            question: "What is the safety distance of flares and banger that have landed on the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"You need to stay away at least 10 mtrs"}, {id:"2",label:"You need to stay away at least 5 mtrs"}, {id:"3",label:"You need to stay away at least 2 mtrs"}, {id:"4",label:"You can get as close as you need to be "}]
          }
        ]
      },
      {
        id: "p6",
        quickEvent: true,
        name: "Pyrotechnics on the pitch – referee intervention (UEFA EURO 2016)",
        injectsTitle: "Notice the intervention by the referee.",
        injects: ["p6"],
        outcomes: ["lo6-1"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+6.jpg",
        tags: ["Situation And Risk Assessment", "Movement"],
        subTags: ["Command and Control"],
        location: "stadium", 
        duration: 60 * 10,
        items: [
          { 
            id: "6a",
            type: "radio",
            question: "There is a flare on the pitch beside a player – what should the referee be doing?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["4"],
            options: [{id:"1",label:"Telling him to keep calm and not to worry"}, {id:"2",label:"Telling him that you will restart the game as the hazard is low"}, {id:"3",label:"Guiding the player away from the pyrotechnic"}, {id:"4",label:"Telling him as captain to ensure all his players gather in the centre circle"}]
          },
          { 
            id: "6b",
            type: "radio",
            question: "Who is in overall control of the players on the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["1"],
            options: [{id:"1",label:"The referee on the pitch"}, {id:"2",label:"The club chairman"}, {id:"3",label:"The FA or UEFA representative at the match"}]
          }
        ]
      },
      {
        id: "p7",
        quickEvent: true,
        name: "Removal pyrotechnics – by players (UEFA EURO 2016)",
        injectsTitle: "Take note of the behaviour of players.",
        injects: ["p7"],
        outcomes: ["lo7-1", "lo7-2", "lo7-3", "lo7-4"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+7.jpg",
        tags: ["Situation And Risk Assessment", "Removal"],
        subTags: ["Situation And Risk Assessment"],
        location: "stadium", 
        duration: 60 * 10,
        items: [
          { 
            id: "7a",
            type: "radio",
            question: "What is the risk of (this) device exploding?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["5"],
            options: [{id:"1",label:"Zero, it cannot happen"}, {id:"2",label:"Low, it almost never happens"}, {id:"3",label:"Medium, as you never sure certified pyrotechnics are used"}, {id:"4",label:"High, as you never know who has bought and used the pyro "}, {id:"5",label:"Unpredictable, as you can never tell what device it is"}]
          },
          { 
            id: "7b",
            type: "radio",
            question: "You see the player kicking the flare with his foot. What would be the right action here?",
            instruction: "",
            duration: 60 * 0.5,
            // correct: ["1"],
            options: [{id:"1",label:"Stop the player trying to remove the flare"}, {id:"2",label:"Let him do it and do nothing"}, {id:"3",label:"Notify your supervisor immediately"}, {id:"4",label:"Signal to the referee that this is dangerous to the player"}]
          }
        ]
      },
      {
        id: "p8",
        quickEvent: true,
        name: "Removal pyrotechnics – stewards pick up by hand (UEFA EURO 2016)",
        injectsTitle: "Observe the response by the stewards.",
        injects: ["p8"],
        outcomes: ["lo8-1"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+8.jpg",
        tags: ["Situation And Risk Assessment", "Means"],
        subTags: ["Bucket"],
        location: "stadium", 
        duration: 60 * 10,
        items: [
          { 
            id: "8a",
            type: "radio",
            question: "What is the point of trying to remove pyrotechnics from the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["3"],
            options: [{id:"1",label:"To get the game restarted as soon as possible"}, {id:"2",label:"To be seen to be showing contempt for those using pyrotechnics"}, {id:"3",label:"The risks of dealing with pyrotechnics outweigh any potential benefit of trying to deal with them"}]
          },
          { 
            id: "8b",
            type: "radio",
            question: "One steward has multiple items in his hands.  Is this:",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"A good idea as it helps clear the pitch as soon as possible"}, {id:"2",label:"Extremely unwise"}, {id:"3",label:"Notify your supervisor immediately"}, {id:"4",label:"Signal to the referee that this is dangerous to the player"}]
          },
          { 
            id: "8c",
            type: "radio",
            question: "Who told him to do this?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["4"],
            options: [{id:"1",label:"No-one – he was just using common sense"}, {id:"2",label:"The club"}, {id:"3",label:"As part of stewards training"}, {id:"4",label:"No-one – in fact he should have been told NOT to do this"}]
          },
          { 
            id: "8d",
            type: "radio",
            question: "The steward (crouching) is picking the pyrotechnic up to place in the specially designed metal bucket.<br>Who is at risk here?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["1", "2"],
            options: [{id:"1",label:"The steward who is picking up the pyrotechnic"}, {id:"2",label:"The steward with the bucket"}, {id:"3",label:"The players"}]
          }
        ]
      },
      {
        id: "p9",
        quickEvent: true,
        name: "Removal pyrotechnics – collecting by stewards (UEFA EURO 2016)",
        injectsTitle: "Look at the way the devices are being treated.",
        injects: ["p9"],
        outcomes: ["lo9-1"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+9.jpg",
        tags: ["Situation And Risk Assessment"],
        subTags: ["Risks and Hazards"],
        location: "stadium", 
        duration: 60 * 10,
        items: [
          { 
            id: "9a",
            type: "radio",
            question: "One steward has multiple items in his hands.<br>Is this:",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"A good idea as it helps clear the pitch as soon as possible"}, {id:"2",label:"Extremely unwise"}]
          },
          { 
            id: "9b",
            type: "radio",
            question: "Who told him to do this?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["4"],
            options: [{id:"1",label:"No-one – he was just using common sense"}, {id:"2",label:"The club"}, {id:"3",label:"As part of stewards training"}, {id:"4",label:"No-one – in fact he should have been told NOT to do this"}]
          },
          { 
            id: "9c",
            type: "checkbox",
            question: "The steward (with a yellow tabard) has picked up a pyrotechnic in one hand with a bucket in the other.<br>What are the risks to the steward here?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["1", "2", "3"],
            options: [{id:"1",label:"Burns to his hand"}, {id:"2",label:"Toxic smoke"}, {id:"3",label:"Risk of amputation"}]
          },
          { 
            id: "9d",
            type: "checkbox",
            question: "Another steward (with an orange tabard) has a specially designed and supplied red bucket with pyrotechnics in – what are the hazards here?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["1", "3"],
            options: [{id:"1",label:"The pyrotechnic bursting and pieces of the bucket acting as shrapnel"}, {id:"2",label:"Very limited hazards once the pyrotechnic is in the bucket"}, {id:"3",label:"Burns while putting the pyrotechnic in the bucket"}]
          },
        ]
      },
      {
        id: "p10",
        quickEvent: true,
        name: "Extinguishing pyrotechnics – stomping into bucket (UEFA EURO 2016)",
        injectsTitle: "Take note of the means of extinction used.",
        injects: ["p10"],
        outcomes: ["lo10-1", "lo10-video", "lo10-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+10.jpg",
        tags: ["Means", "Extinguishing"],
        subTags: ["Bucket"],
        location: "stadium", 
        duration: 60 * 15,
        items: [
          { 
            id: "10a",
            type: "radio",
            question: "This steward is trying to put out a pyrotechnic by stomping on it in a bucket.<br>Is there:-",
            instruction: "",
            duration: 60 * 0.5,
            // correct: ["5"],
            options: [{id:"1",label:"No risk provided he has suitable PPE"}, {id:"2",label:"No risk once the pyrotechnic is in a bucket"}]
          },
          { 
            id: "10b",
            type: "radio",
            question: "This steward is trying to put out a pyrotechnic by stomping on it in a bucket. <br>What is the correct answer?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["4"],
            options: [{id:"1",label:"This will put the pyrotechnic out "}, {id:"2",label:"This may indeed put the pyrotechnic out, but may hurt his foot"}, {id:"3",label:"You need special protection shoes to do this safely"}, {id:"4",label:"Pyrotechnics cannot be extinguished so this is of no use"}]
          },
          { 
            id: "10c",
            type: "radio",
            question: "What is the risk of (this) device exploding?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["5"],
            options: [{id:"1",label:"Zero, it cannot happen"}, {id:"2",label:"Low, it almost never happens"}, {id:"3",label:"Medium, as you never sure certified pyrotechnics are used"}, {id:"4",label:"High, as you never know who has bought and used the pyro "}, {id:"5",label:"Unpredictable, as you can never tell what device it is"}]
          },
        ]
      },
      {
        id: "p11",
        quickEvent: true,
        name: "Extinguishing pyrotechnics – stomping onto pitch (UEFA EURO 2016)",
        injectsTitle: "Take note of the means of extinction adopted.",
        injects: ["p11"],
        outcomes: ["lo11-video", "lo11-1", "lo11-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+11.jpg",
        tags: ["Situation And Risk Assessment", "Extinguishing"],
        subTags: ["Extinguishing"],
        location: "stadium", 
        duration: 60 * 15,
        items: [
          { 
            id: "11a",
            type: "checkbox",
            question: "Multiple flares land on the pitch burning. What may be the harm done to the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            // correct: ["1"],
            options: [{id:"1",label:"The pitch may catch fire"}, {id:"2",label:"The pitch may have severe damage"}, {id:"3",label:"The match may need to be halted"}, {id:"4",label:"The players may be harmed"}]
          },
          { 
            id: "11b",
            type: "radio",
            question: "This steward is trying to put out a pyrotechnic by stomping it on the pitch. <br>What is the correct answer?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["4"],
            options: [{id:"1",label:"This will put the pyrotechnic out"}, {id:"2",label:"This may indeed put the pyrotechnic out, but may hurt his foot"}, {id:"3",label:"You need special protection shoes to do this safely"}, {id:"4",label:"Pyrotechnics cannot be extinguished so this is of no use"}]
          }
        ]
      },
      {
        id: "p12",
        quickEvent: true,
        name: "Pyrotechnics are explosives – risk assessment (UEFA EURO 2016)",
        injectsTitle: "Take a closer look at the steward in the video.",
        injects: ["p12"],
        outcomes: ["lo12-1", "lo12-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+12.jpg",
        tags: ["Pyro Product Knowledge", "Removal"],
        subTags: ["Extinguishing"],
        location: "stadium", 
        duration: 60 * 15,
        items: [
          { 
            id: "12a",
            type: "radio",
            question: "Are any of these pyrotechnics about to explode?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["3"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No"}, {id:"3",label:"I cannot tell"}]
          },
          { 
            id: "12b",
            type: "radio",
            question: "What is the point of trying to remove pyrotechnics from the pitch?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["3"],
            options: [{id:"1",label:"To get the game restarted as soon as possible"}, {id:"2",label:"To be seen to be showing contempt for those using pyrotechnics"}, {id:"3",label:"The risks of dealing with pyrotechnics outweigh any potential benefit of trying to deal with them"}]
          },
        ]
      },
      {
        id: "p13",
        quickEvent: true,
        name: "Pyrotechnics are explosives – impact (UEFA EURO 2016)",
        injectsTitle: "Watch what happens in this situation.",
        injects: ["p13"],
        outcomes: ["lo13-video", "lo13-1", "lo13-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+13.jpg",
        tags: ["Situation And Risk Assessment"],
        subTags: ["Explosives"],
        location: "stadium", 
        duration: 60 * 15,
        items: [
          { 
            id: "13a",
            type: "checkbox",
            question: "One of the pyrotechnics on the pitch has exploded causing a steward and a player to suffer hearing damage. <br>What type of pyrotechnic is involved here?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2", "4"],
            options: [{id:"1",label:"Flare"}, {id:"2",label:"Banger (maroon)"}, {id:"3",label:"Smoke"}, {id:"4",label:"All pyrotechnics can potentially explode"}]
          },
          { 
            id: "13b",
            type: "radio",
            question: "Would this injury have occurred had the referee and stewards had guided everyone away from the pyrotechnics?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No"}]
          },
          { 
            id: "13c",
            type: "radio",
            question: "What have you BEEN TOLD to do?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"I have been told to remove the pyrotechnics to let the match restart as soon as possible"}, {id:"2",label:"I have been told to move away from the pyrotechnics"},  {id:"3",label:"I have been told nothing about specifically how to deal with pyrotechnics"}]
          },
        ]
      },
      {
        id: "p14",
        quickEvent: true,
        name: "Means of personal protection (UEFA EURO 2016)",
        injectsTitle: "Take a detailed look at the means of personal protection worn by the stewards.",
        injects: ["p14"],
        outcomes: ["lo14-1"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+14.jpg",
        tags: ["Means"],
        subTags: ["Personal Protection"],
        location: "stadium", 
        duration: 60 * 15,
        items: [
          { 
            id: "14b",
            type: "radio",
            question: "Do these steward wear the right protection for removing burning pyrotechnic devices?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"Yes"}, {id:"2",label:"No, as the safety distance of any pyrotechnic device does not allow the removal of lit devices "}]
          },
          { 
            id: "14c",
            type: "radio",
            question: "Can you safely remove burning pyrotechnics using tongs?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"Yes, as tongs have extended arms and you are not touching the device"}, {id:"2",label:"No, as the tongs are not long enough to keep within safe distance"}]
          },
        ]
      },
      {
        id: "p15",
        quickEvent: true,
        name: "Extinguishing pyrotechnics – use of sand",
        injectsTitle: "Look at the means of extinction used here.",
        injects: ["p15"],
        outcomes: ["lo15-1", "lo15-2"],
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+15.jpg",
        tags: ["Means"],
        subTags: ["Sand Bags"],
        location: "stadium", 
        duration: 60 * 15,
        items: [
          { 
            id: "15a",
            type: "checkbox",
            question: "Does the use of pyro pillows reduce the risk of harm by pyrotechnic devices?",
            instruction: "",
            duration: 60 * 0.5,
            correct: ["2"],
            options: [{id:"1",label:"Yes, as the pyro pillow smothers the lit pyro "}, {id:"2",label:"No, as you have to be too close to the device to put the pillow on the lit pyrotechnic "}]
          }
        ]
      },
    ],
    injects: [
      {
        id: "1",
        type: "video",
        name: "Twitter Rangers",
        src: "https://cdn.sssponline.com/media/Steward-mocked-on-Twitter-after-Rangers-pitch-invasion-Daily_HD.mp4",
        thumb: "https://cdn.sssponline.com/thumbs/8ae314f5-e9e8-465f-ac05-37c9888144c9.jpg"
      },
      {
        id: "2",
        type: "video",
        name: "Greenpeace Review",
        src: "https://cdn.sssponline.com/media/INCIDENT-REVIEW_GREENPEACE-C.mp4",
        thumb: "https://cdn.sssponline.com/media/Screen-Shot-2020-03-10-at-10.35.58-255x155.png"
      },
      {
        id: "3",
        type: "video",
        name: "Twitter Rangers",
        src: "https://cdn.sssponline.com/media/Steward-mocked-on-Twitter-after-Rangers-pitch-invasion-Daily_HD.mp4",
        thumb: "https://cdn.sssponline.com/media/Screen-Shot-2020-03-10-at-10.35.58-255x155.png"
      },
      {
        id: "4",
        type: "video",
        name: "Greenpeace, Kopenhagen v Real Madrid (HD, 11.12.2013)",
        src: "https://cdn.sssponline.com/media/INCIDENT-REVIEW_GREENPEACE-C.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/MOC+inject+5.jpg"
      },
      {
        id: "10",
        type: "video",
        name: "Case Ukraine vs France (STtT, M8)",
        src: "https://cdn.sssponline.com/media/8ae314f5-e9e8-465f-ac05-37c9888144c9.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/MOC+inject+1.jpg"
      },
      {
        id: "11",
        type: "video",
        name: "Greenpeace, Basel v Schalke (HD, 01.10.2013)",
        src: "https://cdn.sssponline.com/media/12-INCIDENT-REVIEW_GREENPEACE-A.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/MOC+inject+2.jpg"
      },
      {
        id: "12",
        type: "image",
        name: "Home team cheerleaders (11.12.2013)",
        image: "https://cdn.sssponline.com/media/47f277b2-e14a-41fe-b2e0-eabc6c6d9469.JPG",
        thumb: "https://cdn.sssponline.com/media/47f277b2-e14a-41fe-b2e0-eabc6c6d9469-255x155.jpg",
        description: "Action by Greenpeace. At the line up six young females dressed as home team cheerleaders entered the pitch from a vehicle entrance. They were accompanied by six persons masquerading as stewards. Five of these “stewards” had Champions League bibs and the other was dressed in black. They were showing three banners with the message “Gazprom Don`t foul the arctic – Greenpeace”. The girls went off the pitch with the same six “stewards”. They then left the stadium unchallenged and the small banners were found outside. No one was arrested."
      },
      {
        id: "13",
        type: "pdf",
        name: "FC Basel Meeting",
        src: "https://cdn.sssponline.com/prototype/Greenpeace_debrief_FCBasel_Meeting.pdf"
      },
      {
        id: "12b",
        type: "image",
        name: "Go team!",
        image: "https://cdn.sssponline.com/media/47f277b2-e14a-41fe-b2e0-eabc6c6d9469.JPG",
        thumb: "https://cdn.sssponline.com/media/47f277b2-e14a-41fe-b2e0-eabc6c6d9469-255x155.jpg",
        description: "Different text to differentiate."
      },
      {
        id: "12c",
        type: "image",
        name: "Cheering fake",
        image: "https://cdn.sssponline.com/media/47f277b2-e14a-41fe-b2e0-eabc6c6d9469.JPG",
        thumb: "https://cdn.sssponline.com/media/47f277b2-e14a-41fe-b2e0-eabc6c6d9469-255x155.jpg",
        description: "Yes, this one is different as well!"
      },
      {
        id: "a1",
        type: "video",
        name: "Start scenario 3 (Inject, London, 2012)",
        src: "https://cdn.sssponline.com/media/05402341-8a29-47d4-8dbd-3dd51ae8d65e.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+1.jpg",
        description: "<p>According to city authorities, Drax will host over 70’000 supporters of both long-time rivals today. The first match in Drax went well without an incident. The kick-off if the second match is relatively early at 6.00 p.m. </p><p>The city provides two fan zones both with giant screens so that fans without tickets to the fixture can watch the match. One is in the ‘Praça D. João I’ for the German fans. The Dutch fans will be welcomed in the other fan zone in the Campo dos Mártires da Pátria approximately 1 Km away.</p><p>Thousands of fan visitor guides on the campgrounds, on the airport and through fan embassies. The city authorities expect think there may be some 20’000 fans without tickets. But at other tournaments some of these figures were just unimaginable.  </p>        <p>The city authorities believe fan zones help to manage the segregation of rival fans. The fans zones will provide a natural way of segregating the two fans groups so they congregate in separate parts of the city. Each has its own stage and has been organised in collaboration with various other organisations such as official fan organisations from each of the respective countries.</p>        <p>City authorities have also provided transport from fan zones and city centre to the stadium. Fans are well served by both rail and bus services.</p><p>The German paper Tag Zeitung heads “German and Dutch hooligans plan for riots” and quotes unnamed sources from German firms and also has an interview with the Dutch FSA who argue that fan violence in the Dutch competition does not spill-over to the national squad followers</p>        <p>The Continental News has a back-story on the drinking culture of both sets of fans and how an alcohol ban has not been effective in the past years  </p>        <p>The Drax Daily carries the headline challenging the city’s approach and suggests that a heavy hand is what is needed to demonstrate to hooligans who is in control.</p>        <p>And the Dutch Paper AD has an interview with the Dutch Minister of Home Affairs who states that any Dutch fan that misbehaves will be severely punished at home. She also says that authorities have shared the names of about 150 known risk fans to curb the hooligan threat.</p>"
      },
      {
        id: "a2",
        type: "video",
        name: "Media website 24/7 feeds news (Inject, London, 2012)",
        src: "https://cdn.sssponline.com/media/5ed2e46b-f891-446e-8df8-fb0a5e19fefc.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+2.jpg",
        description: "<p>It is now June 15th, 2012. The official site of the ESA – a platform established by and for supporters and maintained by the fan embassies of all participating countries – monitors the supporters’ experience.  This initiative has received much attention and has been widely used in the first days of the tournament.  The day starts quietly but soon becomes busy with thousands of fans arriving by public transport.       From mid-day onwards fans start to gather into large crowds. It is predominantly German fans in the ‘Praça D. João I’ whilst Dutch fans begin to gather in the Campo dos Mártires da Pátria.<p>"
      },
      {
        id: "a3",
        type: "image",
        name: "European Supporters Association: Twitters 15:10 - 15:13 (Inject, 2012)",
        image: "https://cdn.sssponline.com/media/e017cf70-f3ef-4c38-b13f-6f292f8bdaf5.png",
        thumb: "https://cdn.sssponline.com/media/e017cf70-f3ef-4c38-b13f-6f292f8bdaf5-255x155.png",
        description: "<p>Here are the latest twitters of late in the morning:  </p><p>Time 12:18 posted by DoubleDutch “Right you are, getting drunk already in the sun”. New pictures have been added:</p><p>Time 12:17 posted by DutchRule “Following Orange caravan to fan zone. Hear they have Dutch music there and beer!”</p><p>Time: 12:15 posted by WirSindDabei “On our way to fan zone – more are coming!”</p><p>Time 11:45, posted by the German ‘Fan Embassy’ manager: “Hi everybody – we asked permission to park our van in ‘Praça D. João I’”</p><p>Time: 11:43, posted by GermanFan: “nothing to do so far - almost empty of any fans” and posted a picture he took. </p>"
      },
      {
        id: "a4",
        type: "video",
        name: "Briefing Other areas in the city",
        src: "https://cdn.sssponline.com/media/5ed2e46b-f891-446e-8df8-fb0a5e19fefc.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+4.jpg",
        description: "<p>The media website 24/7 feeds news on Drax events from different press agencies and other news sources.</p><p>Fans arriving into the city for some time. While most are heading for the fans zones small groups of opposing fans are gathered in bars throughout the city. While they are in close proximity there have been no problems reported.</p><p>Feed: “Fans intent to get drunk”</p><p>News article on ‘Live-News 24’: with news reporter discussing the many examples of friendly interactions between the two sets of fans that ‘seem to be getting on well’. Including interview with Dutch and German fans expressing their excitement about the fixture and their intention to get drunk’. Could include some critical comment on police deployments – e.g. in ‘low profile decision environments ‘Police seem to be noticeable by their absence. Is this competent in such a risky situation’; in high profile decision environments ‘Police are overreacting’].</p><p>Feed: “Fans move to Centre of Drax”</p><p>“Despite the presence of the fan parks a large gathering of fans starts to develop in the Ribera – a traditional tourist location on the banks of the river ‘Doro’. The crowd is good-humoured and predominantly Dutch. But in the crowd there are small numbers of German fans.”</p>"
      },
      {
        id: "a5",
        type: "video",
        name: "Police Intelligence German spotters",
        src: "https://cdn.sssponline.com/media/46742e01-95b5-4ab0-9099-2615f4e48c0a.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+5.jpg",
        description: "<p>The German Spotting Teams have indentified German Hooligans in the crowd including known Neo-Nazi’s.<br>German fans are singing Anti-Dutch and racist songs (e.g. ‘Holländer Hurensöhne’  or ‘Zick-zack-Zigeunerpack’ ).<br>One radio call has been received that approximately 500 German hooligans are approaching the Ribera from the city centre.</p>"
      },
      {
        id: "a6",
        type: "video",
        name: "RT March announcement",
        src: "https://cdn.sssponline.com/media/6f4c94ee-6c71-4588-98d1-04b82074a542.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+6.jpg",
        description: "<p>The city centre is now very busy with thousands of fans enjoying the celebration. Around city life attempts to go on as normal but inevitably people’s daily routine will be disrupted. The fan parks are full. Approximately six thousand Dutch fans are together in the Campo dos Mártires da Pátria.</p><p>It is approximately five hours from kick-off. The Dutch CIV Spotter team reports that Dutch fans are planning a march from the Campo dos Mártires da Pátria to the stadium. If the march heads off – all are expected to follow, so approximately six thousand will be on the move in an instant.</p>"
      },
      {
        id: "a7",
        type: "video",
        name: "Reporter Patriarch Square",
        src: "https://cdn.sssponline.com/media/fdcebc9a-599c-4d01-903f-043fa941ebc2.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+7.jpg",
        description: "<p>The city centre is now very busy with thousands of fans enjoying the celebration. Around city life attempts to go on as normal but inevitably people’s daily routine will be disrupted. The fan parks are full. Approximately six thousand Dutch fans are together in the Campo dos Mártires da Pátria.</p><p>It is approximately five hours from kick-off. The Dutch CIV Spotter team reports that Dutch fans are planning a march from the Campo dos Mártires da Pátria to the stadium. If the march heads off – all are expected to follow, so approximately six thousand will be on the move in an instant.</p>"
      },
      {
        id: "a8",
        type: "video",
        name: "Item Presenter – busy intersection",
        src: "https://cdn.sssponline.com/media/5c739fe7-fe80-49d8-8afa-b0778f611039.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+8.jpg",
        description: "<p>Fans took matters in their own hands. Authorities arranged bus transport from fan zone to stadium – nice, coordinated, organised. This was a great idea, and in many situations it could have worked like clockwork. However, now we are facing a new, and unplanned event – the march along a route of 6 km. And with 6’000 fans on the move the dynamic of the event changes quickly.</p><p>Still many hours before kick-off, the march approaches a major intersection. The roadway is very busy with traffic and a major node for public transport.</p><p>At this point (points) a section at the front of the crowd sits down in road whilst celebrating. The sit down blocks the roadway and causes major congestion. Cars honking their horns and trying to pass by. It is not clear why the vanguard of the crowd has chosen this moment to stop and what their plans are.</p>"
      },
      {
        id: "a9",
        type: "video",
        name: "Item Presenter – website HooliNews and rumour of planned confrontation",
        src: "https://cdn.sssponline.com/media/c7ad48c7-04d0-42d1-bcd7-6f1b7ed80b73.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/Approach+inject+9.jpg",
        description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p1",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Pyrotechnics thrown onto the pitch",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_01.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+1.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p2",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Multiple pyrotechnics thrown",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_02.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+2.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p3",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Multiple pyrotechnics land on the pitch ",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_03.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+3.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p4",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Movement towards pyrotechnics by stewards",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_04.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+4.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p5",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Movement towards pyrotechnics by players",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_05.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+5.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p6",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Referee intervention",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_06.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+6.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p7",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Touching and kicking pyrotechnics by players",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_07.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+7.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p8",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Removal pyrotechnics by hand",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_08.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+8.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p9",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Collecting pyrotechnics",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_09.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+9.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p10",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Stomping pyrotechnics into bucket to put them out (UEFA EURO 2016)",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_10.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+10.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p11",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Stomping pyrotechnics onto pitch to put them out (UEFA EURO 2016)",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_11.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+11.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p12",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Steward response to unknown pyrotechnics on pitch",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_12.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+12.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p13",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Exploding pyrotechnic",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_13.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+13.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p14",
        type: "video",
        name: "Czech Republic vs Croatia (UEFA EURO 2016) Means of personal protection",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_14.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+14.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "p15",
        type: "video",
        name: "Use of sand to extinguish pyrotechnics",
        src: "https://cdn.sssponline.com/prototype/01+OTJ+PYR+CZECH+REPUBLIC+VS+CROATIA_15.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+15.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "lo1-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide03.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide03.jpg",
      },
      {
        id: "lo1-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide04.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide04.jpg",
      },
      {
        id: "lo2-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide06.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide06.jpg",
      },
      {
        id: "lo2-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide07.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide07.jpg",
      },
      {
        id: "lo2-3",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide08.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide08.jpg",
      },
      {
        id: "lo2-4",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide09.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide09.jpg",
      },
      {
        id: "lo3-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide11.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide11.jpg",
      },
      {
        id: "lo3-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide12.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide12.jpg",
      },
      {
        id: "lo4-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide14.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide14.jpg",
      },
      {
        id: "lo4-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide15.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide15.jpg",
      },
      {
        id: "lo4-3",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide16.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide16.jpg",
      },
      {
        id: "lo5-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide18.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide18.jpg",
      },
      {
        id: "lo5-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide19.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide19.jpg",
      },
      {
        id: "lo6-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide21.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide21.jpg",
      },
      {
        id: "lo7-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide23.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide23.jpg",
      },
      {
        id: "lo7-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide24.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide24.jpg",
      },
      {
        id: "lo7-3",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide25.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide25.jpg",
      },
      {
        id: "lo7-4",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide26.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide26.jpg",
      },
      {
        id: "lo8-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide28.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide28.jpg",
      },
      {
        id: "lo9-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide30.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide30.jpg",
      },
      {
        id: "lo10-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide32.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide32.jpg",
      },
      {
        id: "lo10-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide33.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide33.jpg",
      },
      {
        id: "lo11-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide35.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide35.jpg",
      },
      {
        id: "lo11-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide36.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide36.jpg",
      },
      {
        id: "lo12-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide38.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide38.jpg",
      },
      {
        id: "lo12-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide39.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide39.jpg",
      },
      {
        id: "lo13-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide41.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide41.jpg",
      },
      {
        id: "lo13-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide42.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide42.jpg",
      },
      {
        id: "lo14-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide44.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide44.jpg",
      },
      {
        id: "lo15-1",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide46.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide46.jpg",
      },
      {
        id: "lo15-2",
        type: "image",
        name: "",
        image: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide47.jpg",
        thumb: "https://cdn.sssponline.com/prototype/learning-outcomes/Slide47.jpg",
      },
      {
        id: "lo13-video",
        type: "video",
        name: "",
        src: "https://cdn.sssponline.com/prototype/learning-outcomes/8+PYROTECHNICS+ARE+EXPLOSIVES+NEW.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+LO+video+8.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "lo11-video",
        type: "video",
        name: "",
        src: "https://cdn.sssponline.com/prototype/learning-outcomes/9+SELF+SUSTAINING+FEATURE+PYRO+NEW.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+LO+video+9.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "lo10-video",
        type: "video",
        name: "",
        src: "https://cdn.sssponline.com/prototype/learning-outcomes/11+EFFECTS+OF+CONFINEMENT+NEW.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+LO+video+11.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      },
      {
        id: "lo4-video",
        type: "video",
        name: "",
        src: "https://cdn.sssponline.com/media/25b52b52-395d-4a56-9d10-e07dad59644d.mp4",
        thumb: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/PYR+LO+video+inject+4.jpg",
        // description: "<p>Just prior to the tournament, a website was launched in Germany called HooliNews. This site immediately attracted a lot of media-attention. The site was temporarily shut down by authorities, after it openly called for a confrontation by both German and Dutch self-proclaimed hooligans (presenter opens site). After removal of this message, the site resurfaced and judging the high number of hits is very popular. </p><p>On the site, German and Dutch firms posted a message on June 1st and announced June 15th as the Day of Reckoning. Videos were posted on earlier confrontations. Here are some videos to be found on the site:</p><p>Before being shut down, the site also carried an item how to plan for attack outside the official venues, including fan zones to escape police attention. </p>"
      }
      
    ]
  },
  getters: {
    getScenario(state) {
      return id => state.scenarios.filter(item =>{
        return item.id === id
      })[0];
    },
    getPlaylist(state) {
      return id => state.playlists.filter(item =>{
        return item.id === id
      })[0];
    },
    getInject(state) {
      return id => state.injects.filter(item =>{
        return item.id === id
      })[0];
    },
    getAllPlaylist(state) {
      return state.playlists
    },
    getTimelineInfo: (state, getters) => (id) => {
      let timelineInfo = []
      const playlists = state.scenarios.filter(item =>{
        return item.id === id
      })[0]

      if ( !playlists) {
        return []
      }

      playlists.playlists.forEach(pl => {
        const plInfo = getters.getPlaylist(pl)
        timelineInfo.push({
          id: pl,
          name: plInfo.name,
          timeSlot: plInfo.timeSlot,
          location: plInfo.location,
          items: plInfo.items
        })
      });
      return timelineInfo
    }
  },
  mutations: {
    // addOptions (state, payload) {
    //   state.searchOptions = state.searchOptions.concat(payload)
    // }
  },
  actions: {
    // getLocations (context) {
    //   axios
    //     .get(context.rootState.restUrl + 'location' + '?hide_empty=1')
    //     .then(response => ( context.commit('addOptions', {group:"Locatie", options: response.data})))
    //     .catch(error => console.log(error))
    // }
  }
}
